module.exports = __webpack_public_path__ + "static/media/officialAccounts.62548fd5.png";